// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('dashboard/getData', async () => {
  const response = await axios.get('https://api.fntpf.ir/admin/dashboard')
  return response.data
})


export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    allData: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
  }
})

export default dashboardSlice.reducer
